import { useEffect, useRef, useState } from "react"

/**
 * One debounced window resize tick for a subtree.
 * Buckets width so tiny layout-driven viewport jitter does not retrigger measures.
 */
export default function useWindowResizeTick(debounceMs = 100) {
    const [tick, setTick] = useState(0)
    const timeoutRef = useRef(/** @type {number | null} */(null))
    const widthBucketRef = useRef(
        typeof window !== "undefined" ? Math.floor(window.innerWidth / 8) : 0
    )

    useEffect(() => {
        const onResize = () => {
            if (timeoutRef.current != null) {
                window.clearTimeout(timeoutRef.current)
            }
            timeoutRef.current = window.setTimeout(() => {
                timeoutRef.current = null
                const bucket = Math.floor(window.innerWidth / 8)
                if (bucket === widthBucketRef.current) {
                    return
                }
                widthBucketRef.current = bucket
                setTick((x) => x + 1)
            }, debounceMs)
        }

        window.addEventListener("resize", onResize)
        return () => {
            window.removeEventListener("resize", onResize)
            if (timeoutRef.current != null) {
                window.clearTimeout(timeoutRef.current)
            }
        }
    }, [debounceMs])

    return tick
}
